import { render, staticRenderFns } from "./PersonalProfileListItem.vue?vue&type=template&id=3c4a9aae&scoped=true&"
import script from "./PersonalProfileListItem.vue?vue&type=script&lang=js&"
export * from "./PersonalProfileListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4a9aae",
  null
  
)

export default component.exports